// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function loginWithGoogle(redirectPath = "/portal") {
  try {
    sessionStorage.setItem("post_login_redirect", redirectPath);
  } catch {
    /* ignore */
  }
  const redirectUrl = window.location.origin + "/portal";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
